import React from 'react'
import { css } from '@emotion/css'
import { useAppDispatch } from 'store'
import { useSelector } from 'react-redux'
import {
  selectLocationErrorAlert,
  selectLocationInfoAlert,
  selectLocationSuccessAlert,
  closedAlert,
} from 'features/rental/location/locationAlertSlice'
import { ButtonAddLocation } from 'features/rental/location/ButtonAddLocation'
import { TableLocation } from 'features/rental/location/TableLocation'
import { SnackbarAlert } from 'components/SnackbarAlert'

export function Setting() {
  const errorAlert = useSelector(selectLocationErrorAlert)
  const infoAlert = useSelector(selectLocationInfoAlert)
  const successAlert = useSelector(selectLocationSuccessAlert)

  const dispatch = useAppDispatch()
  return (
    <>
      <SnackbarAlert
        action="error"
        open={errorAlert.isOpen}
        message={errorAlert.message}
        onClose={() => dispatch(closedAlert({ type: 'error' }))}
      />
      <SnackbarAlert
        action="info"
        open={infoAlert.isOpen}
        message={infoAlert.message}
        onClose={() => dispatch(closedAlert({ type: 'info' }))}
      />
      <SnackbarAlert
        action="success"
        open={successAlert.isOpen}
        message={successAlert.message}
        onClose={() => dispatch(closedAlert({ type: 'success' }))}
      />
      <h2>ตั้งค่าการจอง</h2>
      <div
        className={css`
          display: flex;
        `}
      >
        <ButtonAddLocation
          buttonProps={{
            className: css`
              margin-left: auto !important;
            `,
          }}
        />
      </div>

      <TableLocation />
    </>
  )
}

export default Setting
